import { useEffect } from 'react';
import { ClinicTab } from '../tabs/types';
import { useHistory } from 'react-router';

const useNavigateToProductPageOnProductTab = (clinicId: string, currentTab: ClinicTab) => {
  const history = useHistory();

  useEffect(() => {
    if (currentTab === ClinicTab.PRODUCTS) {
      history.push(`/clinics/${clinicId}/products`);
    }
  }, [clinicId, history, currentTab]);
};

export default useNavigateToProductPageOnProductTab;
